<template>
    <div class="table-wrap">
    <header>
      <a href="#" @click.prevent="create()"  class="btn btn-primary" v-if="section && createVoucher">
        <span>Novo Voucher</span>&nbsp;
        <fa :icon="['fal', 'ticket']" />
      </a>
    </header>
    <formulario :scope="tipovoucher" v-if="tipovoucher" />
    <form-spinner v-if="loading" />
    <filter-voucher @onFilter="runFilter($event)" @onClear="clearFilter($event)"/>
    <div class="list-wrap" id="form">
      <table class="transparent-table">
        <thead>
          <tr> 
            <th>Código Voucher</th>
            <th>Vencimento</th>
            <th>Porcentagem</th>
            <th>Valor</th>
            <th>Categoria Loja</th>
            <th>Quem</th>
            <th>Quando</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody >
          <tr v-for="(voucher, i) in vouchers" :key="voucher">
            <td>{{ voucher.codigoVoucher }}</td>
            <td>{{ formatDate(voucher.fim) }}</td>
            <td>{{ voucher.porcentagem ?? '-' }}</td>
            <td>{{ voucher.valor ? formatMoney(voucher.valor) : '-'}}</td>
            <td>{{ voucher.nomeCategoriaLoja ?? '-' }}</td>
            <td>{{ voucher.nomeUso ?? '-'}}</td>
            <td>{{ voucher.dateUsed ? formatDate(voucher.dateUsed) : '-'}}</td>
            <td>
              <span :class="['pill', voucherStatus(voucher)]">
                <fa :icon="['fas', 'ticket']" class="iconStatus" v-if="voucher.status"></fa>
                <fa :icon="['fal', 'ticket']" class="iconStatus" v-else></fa>
                {{ voucherStatus(voucher, true) }}
              </span>
              <!-- <a v-else href="#" class="action">
                <fa :icon="['fas', 'clock']" class="icon color-alert"></fa>
              </a> -->
            </td>
            <td>
              <nav class="actions">
                <a href="#" @click.prevent="confirmRemove(voucher)" v-if="deleteVoucher" :class="['action', { disabled: voucher.status == 1 } ]">
                  <fa :icon="['fal','trash-can']" class="icon"></fa>
                </a>
                <a href="#" @click.prevent="edit(voucher)" v-if="editVoucher" :class="['action', { disabled: voucher.status == 1 } ]">
                  <fa :icon="['fal','pencil']" class="icon"></fa>
                </a>
                <a href="#" @click.prevent="confirmApprove(voucher, i)" :class="['action', { disabled: voucher.aprovado == 1 || voucher.status == 1 || !approveVoucher } ]">
                  <fa :icon="['far','check']" :class="['icon', { active: voucher.aprovado == 1 }]"></fa>
                </a>
              </nav>
          </td>
          </tr>
        </tbody>
      </table>
      <div class="paginator">
        <a href="#" class="prev" @click.prevent="paginate('prev')">
          <fa :icon="['fas','chevron-left']" />
        </a>
        <span>
          {{ page }}
        </span>
        <a href="#" class="next" @click.prevent="paginate('next')">
          <fa :icon="['fas','chevron-right']" />
        </a>
      </div>
    </div>
    <confirm 
      :backdrop="false"
      class="confirm"
      ref="confirm"
    ></confirm>
    <modal ref="modal" :wrapped="false">
      <div>
        <novo-voucher :scope="details" v-if="details && novo" @onClose="closeModal($event)"/>
        <editar-voucher :scope="details" v-if="details && editar" @onClose="closeModal($event)"/>
      </div>
    </modal>
  </div>
</template>

<script>
import Formulario from '@/components/financeiro/vouchers/form/Formulario.vue'
import MarketplaceService from '@/services/marketplace.service.js'
import FinanceiroService from '@/services/financeiro.service.js'
import UserService from '@/services/user.service.js'
import { formatDate, formatMoney } from '@/services/utils.service.js'

import NovoVoucher from '@/components/financeiro/vouchers/form/NovoVoucher.vue'
import EditarVoucher from '@/components/financeiro/vouchers/form/EditarVoucher.vue'
import Modal from '@/components/utilities/Modal.vue'
import FormSpinner from '@/components/utilities/FormSpinner.vue'
import FilterVoucher from '@/components/financeiro/vouchers/form/FilterVoucher.vue' 

import moment from 'moment'
export default {
  components:{
      Formulario, Modal, NovoVoucher, EditarVoucher, FormSpinner, FilterVoucher
  },
  props: {
      section: {
          type: String,
      },
      id: {
          type: [String, Number]
      }
  },
  data() {
    return {
      tipovoucher: null,
      vouchers: [],
      page: 1,
      max: 0,
      details: null,
      novo: false,
      editar: false,
      loading: false,
      editVoucher: false,
      approveVoucher: false,
      createVoucher: false,
      filter: {
        codigoVoucher: null,
        vencimentoInicial: null,
        vencimentoFinal: null,
        status: null
      }
    }
  },
  mounted() {
    this.editVoucher = UserService.filterPermissions('editVoucher')
    this.createVoucher = UserService.filterPermissions('createVoucher')
    this.approveVoucher = UserService.filterPermissions('approveVoucher')

    if ( this.id ) {
      this.getTipoVoucher(this.id)
      this.getVouchers(this.id)
    }
  },
  methods: {
    formatDate ( date ) {
      return formatDate(date)
    },
    formatMoney ( value ) {
      return formatMoney(value)
    },
    getTipoVoucher(idTipoVoucher) {
      MarketplaceService.getTipoVoucher(idTipoVoucher)
      .then((response) => {
        this.tipovoucher = response.data.filter( a => a.idTipoVoucher == idTipoVoucher )[0] 
      })
    },
    getVouchers(idTipoVoucher) {
      this.loading = true
      MarketplaceService.getVouchersFromTipo(idTipoVoucher, this.page)
      .then((response) => {
        // console.log("getVouchersFromTipo:", response)
        this.vouchers = response.data.data
        this.max = response.data.last_page

        const targetElement = document.getElementById("form")
        targetElement.scrollIntoView({
            behavior: "smooth",
            block: "start"
        })
      }).catch( error => {
        window.toaster.emit('open', { style: 'error', message: 'Ops! Algo aconteceu. Não foi possível listar os vouchers. ' + error, floater: true })
      }).finally(() => {
        this.loading = false
      })
    },
    voucherStatus ( voucher, msg ) {
      var status = ''
      
      if ( voucher.status == 1 && voucher.dateUsed ) {
        status = msg ? 'Utilizado' : 'bg-success'
      } else {
        const dateDiff = moment(voucher.fim).diff(moment(), 'days')
        if ( dateDiff < 0 ) {
          status = msg ? 'Expirado' : 'bg-alert'
        } else {
          status = msg ? 'Pendente' : 'bg-text'
        }
      }

      return status
    },
    paginate ( dir ) {
      const current = this.page
      console.log("current:", current)
      console.log("max:", this.max)
      console.log("dir:", dir)

      if ( dir == 'next' && current < this.max ) {
        const next = current + 1
        this.page = next
        console.log("next:", next)

        this.getVouchers(this.id)
      }
      if ( dir == 'prev' && current > 1 ) {
        const prev = current - 1
        this.page = prev
        console.log("prev:", prev)

        this.getVouchers(this.id)
      }

    },
    edit( voucher ) {
      const options = {
        title: 'Editar voucher',
        titleAlign: "center",
        message: this.tipovoucher.nomeTipoVoucher,
        size: "mid", //small, mid, normal, large, full
        backdrop: true,
        backdropColor: "transparent",  //se o backdrop for false, não precisa
        backdropClose: true,
        padding: '0',
        // onClose: this.closeEdit
      }

      this.details = voucher
      this.editar = true
      this.novo = false
      
      console.log("edit:", this.details)
      this.$refs.modal.open(options)
      // this.$router.push({ name: 'Vouchers', params: { section: 'editar', id } })
    },
    create() {
      console.log("scope:", this.tipovoucher)

      const options = {
        title: 'Novo Voucher',
        titleAlign: "center",
        message: this.tipovoucher.nomeTipoVoucher,
        size: "large", //small, mid, normal, large, full
        backdrop: true,
        backdropColor: "transparent",  //se o backdrop for false, não precisa
        backdropClose: true,
        padding: '0',
        // onClose: this.closeEdit
      }

      this.editar = false
      this.novo = true
      this.details = this.tipovoucher
      
      console.log("create:", options)
      this.$refs.modal.open(options)
      // this.$router.push({ name: 'Vouchers', params: { section: 'editar', id } })
    },
    confirmRemove(voucher) {
      this.$refs.confirm.run({
        message: "Tem certeza que deseja remover o voucher selecionado?",
        confirmButton: "Sim",
        denyButton: "Não",
        data: voucher,
        callback: this.deleteVoucher,
      })
    },
    deleteVoucher ( response, voucher ) {
      if ( response ) {
        window.spinner.emit('open')
        console.log('deleteVoucher:', voucher)
        FinanceiroService.deleteVoucher(voucher.idVoucher)
        .then( response => {
          console.log('response:', response.data)
          this.getVouchers(this.id)
          window.toaster.emit('open', { style: 'success', message: `Tudo certo! Voucher ${ voucher.codigoVoucher } deletado com sucesso`, floater: true })
        })
        .catch( error => {
          console.error(error)
          window.toaster.emit('open', { style: 'error', message: `Ops! Algo aconteceu. Não foi possível remover o voucher ${ voucher.codigoVoucher }.`, floater: true })
        })
        .finally(() => {
          window.spinner.emit('close')
        })
      }      
    },
    closeModal (refresh) {
      this.$refs.modal.close()

      if ( refresh ) this.getVouchers(this.id)
    },
    confirmApprove ( voucher, i ) {
      if ( !this.approveVoucher ) {
        window.toaster.emit('open', { style: 'error', message: 'Você não tem permissão para aprovar um voucher.', floater: true })
        return false
      }

      this.$refs.confirm.run({
        message: `Tem certeza que deseja aprovar o voucher ${voucher.codigoVoucher}?`,
        confirmButton: "Sim",
        denyButton: "Não",
        data: { voucher, i },
        callback: this.approve,
      })
    },
    approve ( response, data ) {
      if ( response ) {
        const { voucher, i } = data

        console.log('approve:', voucher)
        const payload = {
          idsTipoVoucher: [],
          idsVouchers: [voucher.idVoucher]
        }
        FinanceiroService.aprovarVouchers(payload)
        .then(() => {
          window.toaster.emit('open', { style: 'success', message: `Tudo certo! Voucher ${ voucher.codigoVoucher } aprovado com sucesso`, floater: true })
          this.vouchers[i].aprovado = 1
        })
        .catch( error => {
          console.error(error)
          window.toaster.emit('open', { style: 'error', message: `Ops! Algo aconteceu. Não foi possível aprovar o voucher ${ voucher.codigoVoucher }.`, floater: true })
        })
        .finally(() => {
          window.spinner.emit('close')
        })
      }
    },
    runFilter ( options ) {
      console.log("options:", options)
      this.loading = true
      this.filter = {
        codigoVoucher: options.codigoVoucher ?? 0,
        vencimentoInicial: options.vencimentoInicial ?? 0,
        vencimentoFinal: options.vencimentoFinal ?? 0,
        status: options.status ?? 0
      }
      const pager = {
        page: 1,
        perPage: 100
      }
      MarketplaceService.filterVoucher(this.id, this.filter, pager)
        .then( response => {
          console.log('filterVoucher:', response.data)
          this.vouchers = response.data.data
          this.max = response.data.last_page

          const targetElement = document.getElementById("form")
          targetElement.scrollIntoView({
              behavior: "smooth",
              block: "start"
          })
          
        })
        .catch ( error => {
          console.error(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearFilter() {
      this.filter = {
        codigoVoucher: null,
        vencimentoInicial: null,
        vencimentoFinal: null,
        status: null
      }

      this.getVouchers(this.id)
    }
  }
}

</script>

<style lang="scss" scoped>

header {
  justify-content: flex-end;
  display: flex;
  padding: $hmg_mid
}

// header {
//   padding: $hmg_small;

//   &.header {
//     padding: $hmg_small;
//     display: flex;
//     align-items: center;
//   }

//   h4 {
//     margin: 0;
//   }
//   .btn {
//     display: flex;
//     justify-content: flex-end;
//   }
// }
  

  .transparent-table{
    position: relative;
    top: 10px;
    th, td {
      //text-align: center;

      &:last-child {
        max-width: 100px;

      }
    }
  }
  .table-wrap {
    // padding: $mg $hmg_small $mg_extra;
  }
  .actions {
    display: flex; align-items: center; gap: $mg_mini;
    justify-content: flex-end; 
    width: 100%;

    a {
      display: flex; flex-direction: column;
      align-items: center; justify-content: center;
      padding: 0 $mg_mini;

      &.disabled {
        opacity: .5;
        pointer-events: none;
      }
      
      .icon.active {
        color: $color-success-2;
      }
    }


    &.locked {
      a {
        pointer-events: none;
      }
    }
  }

  .list-wrap {
    border-top: $border-component;
    padding: $hmg_mid;
  }

  .pill {
    border-radius: 2em;
    padding: $hmg_mini $mg_mini;
    color: $color-secondary;

    .iconStatus {
      color: $color-secondary;
    }
  }
  


  .paginator {
    display: flex;
    align-content: center; align-items: center;
    justify-content: center;
    margin: $mg_mid 0 $mg;
    gap: $mg_mini;
    font-size: 16px;
    
    > span {
      display: flex; flex-shrink: none;
      width: 40px; height: 40px; border-radius: 100%;
      flex-direction: column; align-content: center; justify-content: center;
      text-align: center;
      background-color: $color-secondary;
      cursor: default;
    }
    
    a:hover {
      color: $color-primary
    }
  }
</style>
